import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const finRoutes: Routes = [
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'banco',
    loadChildren: () =>
      import('../pages/fin/banco/banco.module').then(
        (module) => module.BancoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'condicao-pagamento',
    loadChildren: () =>
      import(
        '../pages/fin/condicao-pagamento/condicao-pagamento.module'
      ).then((module) => module.CondicaoPagamentoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'creceber',
    loadChildren: () =>
      import('../pages/fin/titulo/titulo.module').then(
        (module) => module.TituloModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cpagar',
    loadChildren: () =>
      import('../pages/fin/titulo/titulo.module').then(
        (module) => module.TituloModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'relatorio-creceber',
    loadChildren: () =>
      import('../pages/fin/relatorio-titulo/relatorio-titulo.module').then(
        (module) => module.RelatorioTituloModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'relatorio-cpagar',
    loadChildren: () =>
      import('../pages/fin/relatorio-titulo/relatorio-titulo.module').then(
        (module) => module.RelatorioTituloModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'relatorio-comissao',
    loadChildren: () =>
      import(
        '../pages/fin/relatorio-comissao/relatorio-comissao.module'
      ).then((module) => module.RelatorioComissaoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'remessa',
    loadChildren: () =>
      import(
        '../pages/fin/remessa/remessa.module'
      ).then((module) => module.RemessaModule),
    canActivate: [AuthGuard],
  },
  {
    path: "bloqueio-financeiro",
    loadChildren: () =>
      import("../pages/cml/bloqueios/bloqueios.module").then(
        (module) => module.BloqueiosModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
